export const OBJECTSTORAGEBILLING = "OBJECTSTORAGEBILLING";
export default OBJECTSTORAGEBILLING;